import * as React from 'react';

function useCallbackRef(r){const t=React.useRef(r);return React.useEffect((()=>{t.current=r;})),React.useMemo((()=>(...e)=>{var r;return null===(r=t.current)||void 0===r?void 0:r.call(t,...e)}),[])}

export { useCallbackRef };
